import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import EyeIcon from '@wix/da-ds/pkg/Icons/Eye';
import UnwatchIcon from '@wix/da-ds/pkg/Icons/Unwatch';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { canPeek } from '../../utils';
import { CommentContext } from '../../CommentContext';
import CommentDataAttrDiv from '../../lego/CommentDataAttrDiv';
import s from './HiddenView.scss';
const HiddenView = ()=>{
    const { t } = useTranslation();
    const { setPeeking, comment } = useContext(CommentContext);
    return /*#__PURE__*/ React.createElement(CommentDataAttrDiv, {
        className: s['root']
    }, canPeek(comment) && /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: c(s['hidden'], s['peekable']),
        onClick: ()=>setPeeking(true)
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['hidden-text']
    }, /*#__PURE__*/ React.createElement(UnwatchIcon, {
        className: s['hidden-icon']
    }), t('comment.visibility.hidden')), /*#__PURE__*/ React.createElement("span", {
        className: s['hidden-text-hover']
    }, /*#__PURE__*/ React.createElement(EyeIcon, {
        className: s['hidden-icon']
    }), t('comment.visibility.hidden.showComment'))), !canPeek(comment) && /*#__PURE__*/ React.createElement("div", {
        className: s['hidden']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['hidden-text']
    }, /*#__PURE__*/ React.createElement(UnwatchIcon, {
        className: s['hidden-icon']
    }), t('comment.visibility.hidden'))));
};
HiddenView.displayName = 'HiddenView';
export default HiddenView;
